import { CommentList } from "../../components/CommentList";
import { CommentForm } from "../../components/Form";

export default function Comment(props) {
    return (
        <>
            <div className="card border-10 mb-5">
                <div className="card-body">
                    <div className="accordion" id="kt_accordion_1">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="kt_accordion_1_header_1">
                                <button className="accordion-button fs-4 fw-bold collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#kt_accordion_1_body_1" aria-expanded="false"
                                    aria-controls="kt_accordion_1_body_1">
                                    فیلترهای درخواست شده
                                </button>
                            </h2>
                            <div id="kt_accordion_1_body_1" className="accordion-collapse collapse"
                                aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                                <div className="accordion-body">
                                    <div className="d-flex flex-column flex-lg-row">
                                        <div className="flex-lg-row-fluid mt-10 me-lg-15 order-2 order-lg-1 mb-10 mb-lg-0">
                                            <div className="card border-16 pt-3 mb-5 mb-xl-10 h-550px overflow-scroll">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <CommentList {...props} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-column flex-lg-row-auto w-lg-350px w-xl-500px mb-5 order-1 order-lg-2">
                                            <div className="card card-flush mt-10 mb-lg-10 mb-md-10 mb-5 border-16" data-kt-sticky="false"
                                                data-kt-sticky-offset="{default: 'auto', lg: '500px'}"
                                                data-kt-sticky-width="{lg: '350px', xl: '500px'}"
                                                data-kt-sticky-left="auto" data-kt-sticky-top="150px" data-kt-sticky-animation="true"
                                                data-kt-sticky-zindex="95">
                                                <div className="card-header">
                                                    <div className="card-title">
                                                        <h3>فرم سفارش فیلتر بورس</h3>
                                                    </div>
                                                </div>
                                                <div className="card-body pt-0 fs-6">
                                                    <div className="separator separator-dashed mb-7" />
                                                    <CommentForm {...props} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}
